export const STEP = {
	ONE: 0,
	TWO: 1,
	THREE: 2,
	FOUR: 3,
	FIVE: 4
} as const;
